export default __webpack_public_path__ + "static/media/yellow-skillit-logo.ee3f02bb.svg";